import './startPreloader.css'

const StartPreloader = () => {

    return <div className={'start_preloader_container'}>
        <div className="container2">
            <div className="container">
                <div className="part2">
                    Social
                </div>
                <div className="part1">
                    Network
                </div>
            </div>
            <div className="loader">
                <div className="loading">
                </div>
            </div>
        </div>
    </div>
}

export default StartPreloader;